import { Box, Typography } from '@mui/material'
import PropTypes from 'prop-types'

import { STATUSES_OPTIONS } from './table-status.constants'
import { styles } from './table-status.style'

const TableStatus = ({ status }) => {
  const normalizedStatus = status.toLowerCase()

  switch (normalizedStatus) {
    case STATUSES_OPTIONS.active.key.toLowerCase():
      return (
        <Box sx={styles.activeStatusContainer}>
          <Typography variant="header4" color="success.dark">
            {STATUSES_OPTIONS.active.label}
          </Typography>
        </Box>
      )
    case STATUSES_OPTIONS.inactive.key.toLowerCase():
      return (
        <Box sx={styles.inactiveStatusContainer}>
          <Typography variant="header4" sx={styles.inactiveStatusText}>
            {STATUSES_OPTIONS.inactive.label}
          </Typography>
        </Box>
      )
    default:
      return null
  }
}

TableStatus.propTypes = {
  status: PropTypes.string.isRequired,
}

export default TableStatus
